import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-success-modal',
    templateUrl: './success-modal.component.html',
    styleUrls: ['./success-modal.component.scss']
})
export class SuccessModal {

    @Input() title = '';
    @Input() content = '';
    @Input() buttonText = 'Chiudi';

    constructor(
        public activeModal: NgbActiveModal,
    ) {}
}